module.exports = __webpack_public_path__ + "static/media/artwork_7.f508539d.png";